<template>
    <nav
        class="navbar primary navbar-expand-lg"
    >
        <div class="container">
            <ul class="navbar-nav primary">
                <li class="nav-item dropdown">
                    <a
                        class="nav-link dropdown-toggle"
                        href="javascript:void(0);"
                        id="navbarPrimaryDropdown"
                        role="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                    >
                        <img
                            src="/assets/images/root/icon-user-1.png"
                        />
                    </a>
                    <div
                        class="dropdown-menu"
                        aria-labelledby="navbarPrimaryDropdown"
                    >
                        <div
                            class="menu-header"
                        >
                            <div
                                class="header-icon"
                            >
                                <div
                                    class="icon"
                                >
                                    <img
                                        src="/assets/images/root/icon-user-1.png"
                                    />
                                    </div>
                            </div>
                            <div
                                class="header-text"
                            >
                                <div
                                    class="title"
                                >
                                    <h3>
                                        {{ userInfoData?.name?.split(' ')[0] }}
                                    </h3>
                                </div>
                                <div
                                    class="subtitle"
                                >
                                    <h4>
                                        {{ userInfoData?.name?.split(' ')[1] }}
                                    </h4>
                                </div>
                            </div>
                        </div>
                        <div
                            class="menu-content"
                        >
                            <div
                                class="content-link"
                            >
                                <div
                                    class="link"
                                >
                                    <a
                                        class="link-content"
                                        @click="openModalUser"
                                        style="cursor: pointer;"
                                    >
                                        Dados da
                                        conta
                                    </a>
                                </div>
                                <div
                                    class="link"
                                >
                                    <a
                                        class="link-content"
                                        @click="logout"
                                    >
                                        Sair
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </nav>

    <ModalUser />
</template>

<script>
    import { mapState, mapActions } from 'vuex';
    import ModalUser from '@/components/modals/modalUser.vue';

    export default {
        
        data() {
            return {
              
                userData: {
                    name: '',
                    email: '',
                    password: ''
                },
               
            };
        },
        components: {
            ModalUser
        },
        computed: {
            ...mapState(['user'])
        },
        methods: {
            ...mapActions(['storeToken', 'storeRefreshToken', 'storeIsVisibleModalUser']),
            logout() {
                this.storeToken({ token: null });
                this.storeRefreshToken({ refreshToken: null });
                this.$router.push('/login');
            },
            openModalUser() {
                this.storeIsVisibleModalUser({ isVisibleModalUser: true });
            },
        }
      
    }
</script>

<style lang="scss" scoped></style>
<style scoped>
.loading-dots {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
}

.loading-dots-content {
    display: flex;
    gap: 8px;
}

.dot {
    width: 8px;
    height: 8px;
    background-color: #4FCCEA;
    border-radius: 50%;
    animation: fade 1.5s infinite;
}

.dot:nth-child(2) {
    animation-delay: 0.5s;
}

.dot:nth-child(3) {
    animation-delay: 1s;
}

@keyframes fade {
    0%, 100% {
        opacity: 0;
    }
    50% {
        opacity: 1;
    }
}

.value-text p {
    color: white;
}

.chat-container {
    height: calc(100vh - 200px);
    overflow-y: auto;
    display: flex;
    flex-direction: column;
}

.chat-container::-webkit-scrollbar {
    width: 8px;
}

.chat-container::-webkit-scrollbar-track {
    background: transparent;
}

.chat-container::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
}

.chat-container::-webkit-scrollbar-thumb:hover {
    background: #555;
}
</style>
